import React from "react"

export default function LevelItem(props) {
  return (
    <div {...props} className={`level-item ${props.className}`}>
      {props.children}
    </div>
  )
}
